// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import CSSTransition from 'react-transition-group/CSSTransition';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import Experiment from '@homeaway/react-experiment';

import {HA_SERP_MAP_SEARCH_HERE_BTN} from '../../abacus/experiments';
import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './SearchHereButton.less';

export type SearchHereButtonProps = {
    isVisible: boolean,
    onClick: Function,
    shouldDisableSearchButton: boolean,
    isLoading: boolean
};

function onClickHandler(onClick) {
    return function onClickPropHandler() {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'map search button click'
        });
        onClick();
    };
}

const SearchHereButton = ({
    isVisible,
    onClick,
    shouldDisableSearchButton,
    isLoading
}: SearchHereButtonProps) => (
    <div>
        <CSSTransition
            in={isVisible}
            classNames="Map__searchHere__transition"
            timeout={400}
            mountOnEnter
            unmountOnExit
        >
            <div className="Map__search" data-wdio="Map__search">
                <button
                    key="searchhereShow"
                    type="button"
                    className="btn btn-primary"
                    onClick={onClickHandler(onClick)}
                    data-wdio="Map__search"
                    disabled={shouldDisableSearchButton}
                >
                    <Experiment name={HA_SERP_MAP_SEARCH_HERE_BTN}>
                        {({Variant, Off}) => (
                            <React.Fragment>
                                <Variant variant={1}>
                                    <FormattedMessage
                                        id="onlySearchInThisArea"
                                        description="Only search in this area"
                                        defaultMessage="Only search in this area"
                                    />
                                </Variant>
                                <Variant variant={2}>
                                    <FormattedMessage
                                        id="redoSearchHere"
                                        description="Redo search here"
                                        defaultMessage="Redo search here"
                                    />
                                </Variant>
                                <Variant variant={3}>
                                    <FormattedMessage
                                        id="searchThisArea"
                                        description="Search this area"
                                        defaultMessage="Search this area"
                                    />
                                </Variant>
                                <Off>
                                    <FormattedMessage
                                        id="searchHere"
                                        description="Search here"
                                        defaultMessage="Search here"
                                    />
                                </Off>
                            </React.Fragment>
                        )}
                    </Experiment>
                </button>
            </div>
        </CSSTransition>
        <LoadingOverlay loading={isLoading} />
    </div>
);

export default SearchHereButton;
